import { MutationTree } from 'vuex';
import { AuthOnBehalfOfConfig } from '@andromeda/polaris-data-access-products';
import { IKrogerCheckoutState } from './state';
import { SET_KROGER_AUTH_CONFIG, SET_GO_TO_CART_OPEN } from './types';

const mutations: MutationTree<IKrogerCheckoutState> = {
    [SET_KROGER_AUTH_CONFIG]: (state, authConfig: AuthOnBehalfOfConfig) => {
        state.krogerAuthConfig = authConfig;
    },
    [SET_GO_TO_CART_OPEN]: (state, open: boolean) => {
        state.goToCartOpen = open;
    },
};

export default mutations;
